import { useSettings } from "contexts/settings";
import { getPermissionName } from "shared/constants/permissions";

//TODO: Move permissions to src\contexts\permissions\use-view-only-permissions.js
export const useViewOnlyPermissions = (permission, task, redoTask = "") => {
    const { hasReadOnlyPermission } = useSettings();
    const permissionName = getPermissionName(permission, task, redoTask);

    return permissionName ? hasReadOnlyPermission(permissionName) : false;
};
